const monthNames = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
  'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
];

const MONTH_RANGE_START = -6;
const MONTH_RANGE_END = 6;

const getDateOptions = (withAll = true) => {
  const dateOptions = [];
  withAll ? dateOptions.push({label: 'Wszystkie'}) : null;
  for (let i = MONTH_RANGE_START; i <= MONTH_RANGE_END; i++)
  {
    let date = new Date();
    date.setMonth(date.getMonth() + i);
    let month = date.getMonth();
    let year = date.getFullYear();
    let dateFrom = new Date(year, month, 2);
    dateFrom.setUTCHours(0, 0, 0, 0);
    let dateTo = new Date(year, month + 1, 1);
    dateTo.setUTCHours(23, 59);
    dateOptions.push(({value: {dateFrom: dateFrom.toISOString(), dateTo: dateTo.toISOString()}, label: `${year} ${monthNames[month]}`}));
  }
  return dateOptions;
};

export const DateService = {
  getDateOptions
};